module.exports = __webpack_public_path__ + "img/user.9c1b2d6e.png";